// extracted by mini-css-extract-plugin
export default {"form":"style_form__8tnv7","formInputContainer":"style_formInputContainer__emOJZ","errorText":"style_errorText__+edF+","submit":"style_submit__x8zl-","mb0":"style_mb0__RwJfR"};